import { useState } from "react"
import styles from "./live-stream-viewer.module.css"

export default function LiveStreamViewer({ tournament, autoTitle }) {
  const [isStreaming, setIsStreaming] = useState(true)
  const [showStreamSettings, setShowStreamSettings] = useState(false)

  const handleStartStream = () => {
    setIsStreaming(true)
    alert("Stream started! OBS/WebRTC connection initiated.\nStream Key: PIXEL_MOON_" + tournament.id)
  }

  const handleStopStream = () => {
    setIsStreaming(false)
    alert("Stream stopped and saved to cloud storage.")
  }

  return (
    <div className={styles.streamContainer}>
      <div className={styles.videoPlayer}>
        <img src={tournament.streamUrl || "/placeholder.svg"} alt="Live Stream" className={styles.streamImage} />

        <div className={styles.streamOverlay}>
          <div className={styles.streamTitle}>{autoTitle}</div>

          <div className={styles.streamStats}>
            <div className={styles.stat}>
              <span className={styles.statIcon}>👥</span>
              <span>{tournament.viewers.toLocaleString()} watching</span>
            </div>
            <div className={styles.stat}>
              <span className={styles.statIcon}>🎮</span>
              <span>{tournament.format}</span>
            </div>
            <div className={styles.stat}>
              <span className={styles.statIcon}>💰</span>
              <span>{tournament.prizePool}</span>
            </div>
          </div>

          {isStreaming && <div className={styles.liveBadge}>● LIVE</div>}
        </div>
      </div>

      <div className={styles.streamControls}>
        <div className={styles.controlsHeader}>
          <h3>Stream Controls</h3>
          <button className={styles.settingsBtn} onClick={() => setShowStreamSettings(!showStreamSettings)}>
            ⚙️
          </button>
        </div>

        <div className={styles.buttonGroup}>
          {!isStreaming ? (
            <button className={styles.startBtn} onClick={handleStartStream}>
              <span className={styles.btnIcon}>▶</span>
              Start Live Stream
            </button>
          ) : (
            <button className={styles.stopBtn} onClick={handleStopStream}>
              <span className={styles.btnIcon}>⏹</span>
              Stop Stream
            </button>
          )}
        </div>

        {showStreamSettings && (
          <div className={styles.settingsPanel}>
            <div className={styles.settingItem}>
              <label>Stream Key</label>
              <input type="text" value={`PIXEL_MOON_${tournament.id}`} readOnly className={styles.input} />
              <button className={styles.copyBtn}>Copy</button>
            </div>

            <div className={styles.settingItem}>
              <label>Server URL</label>
              <input type="text" value="rtmp://stream.pixelmoon.io/live" readOnly className={styles.input} />
              <button className={styles.copyBtn}>Copy</button>
            </div>

            <div className={styles.settingItem}>
              <label>Stream Title (Auto-Generated)</label>
              <input type="text" value={autoTitle} readOnly className={styles.input} />
            </div>

            <div className={styles.settingItem}>
              <label>Bitrate</label>
              <select className={styles.select}>
                <option>2500 kbps (Recommended)</option>
                <option>3500 kbps (High Quality)</option>
                <option>1500 kbps (Low Bandwidth)</option>
              </select>
            </div>

            <div className={styles.instructions}>
              <h4>OBS Setup Instructions:</h4>
              <ol>
                <li>Open OBS Studio</li>
                <li>Go to Settings → Stream</li>
                <li>Select "Custom Streaming Server"</li>
                <li>Paste the Server URL and Stream Key above</li>
                <li>Click "Start Streaming"</li>
              </ol>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
